import './App.css';

import {Route, BrowserRouter as Router, Routes} from "react-router";
import "@fontsource/poppins";
import {TokenProvider} from "./Context/TokenContext";
import {UserProvider} from "./Context/UserContext";
import Main from "./Componant/Main";
import {Authentication} from "./Componant/Anthantication/Authentication";
import SharePage from "./Page/SharePage";
import SecureSharePage from "./Page/SecureSharePage";
import ActivateAccountPage from "./Page/ActivateAccountPage";
import {CookiesProvider} from "react-cookie";


function App() {


    return (
        <div className="App" style={{
            minHeight: '100vh'
        }}>
            <CookiesProvider>
                <TokenProvider>
                    <UserProvider>
                        <Router>
                            <Main/>
                            <Routes>
                                <Route exact path="/authentication/callback" element={<Authentication/>}/>
                                <Route path="/share/:token" element={<SharePage/>}/>
                                <Route path="/secure-share/:share_id" element={<SecureSharePage/>}/>
                                <Route path="/activer-compte" element={<ActivateAccountPage/>}/>
                            </Routes>
                        </Router>
                    </UserProvider>
                </TokenProvider>
            </CookiesProvider>
        </div>
    );
}

export default App;
